import { isFilled } from "@prismicio/client";
import { PrismicImage, PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.LogoSlice} LogoSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<LogoSlice>} LogoProps
 * @type {import("react").FC<LogoProps>}
 */
const Logo = ({ slice }) => {

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="framing padding-x padding-y text-black flex flex-col gap-7 text-center"
    >
      {isFilled.richText(slice.primary.title) && (
        <PrismicRichText
          field={slice.primary.title} components={{
            heading2: ({ children }) => <h2 className="h3">{children}</h2>,
          }} />
      )}

      {isFilled.image(slice.primary.image) && (
        <PrismicImage className="w-full h-full"
          field={{
            ...slice.primary.image,
            alt: slice.primary.image.alt || "Image d'illustration",
          }}
        />
      )}
    </section>
  );
};

export default Logo;
